import { useSelector } from "react-redux";
import useSwr from "swr";
import { InvoiceApi, branchApi } from "../apis";
import { usePermission } from "../components/permission";
import type { IAuth } from "../interfaces/IAuth";

type Options = {
  id: string | undefined;
};

export function useInvoiceFormData({ id }: Options) {
  const INV_LIST = usePermission("INV_LIST");
  const { hasAccess: branchHasAccess } = usePermission("INV_ACCEPT_BUYER_PAYMENT");
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);

  const isNew = id === "new";
  const canFetchInvoice = !!id && !isNew && INV_LIST.hasAccess;

  const { data: invoice, isLoading: isLoadingInvoice } = useSwr<any>(
    canFetchInvoice ? `/api/invoice/${id}` : null,
    canFetchInvoice ? async () => await InvoiceApi.get(`${id}`) : null,
  );

  const canFetchBranches = !!user?.currentBusiness.id && branchHasAccess;
  // Shared with invoice-sender-form so empty-query branch select is one SWR cache entry.
  const { data: businessList, isLoading: isLoadingBranches } = useSwr<any[]>(
    canFetchBranches ? ["branch-select", user.currentBusiness.id, ""] : null,
    canFetchBranches
      ? async () => await branchApi.select({ businessId: user.currentBusiness.id, query: "" })
      : null,
    { fallback: [] },
  );

  return {
    user,
    isNew,
    INV_LIST,
    invoice,
    businessList: businessList ?? [],
    isLoading: (isLoadingInvoice && !isNew) || isLoadingBranches,
  };
}
